/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_X_Padding_Range_ErrorInputs */



/**
* | output |
* | --- |
* | "Horizontal padding must be between 0 and 50" |
*
* @param {Iframe_Remote_X_Padding_Range_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_x_padding_range_error = /** @type {((inputs?: Iframe_Remote_X_Padding_Range_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_X_Padding_Range_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le padding horizontal doit etre entre 0 et 50")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der horizontale Abstand muss zwischen 0 und 50 liegen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La spaziatura orizzontale deve essere compresa tra 0 e 50")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Горизонтальный отступ должен быть в диапазоне от 0 до 50.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El relleno horizontal debe estar entre 0 y 50")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("水平边距必须介于 0 和 50 之间。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("水平方向のパディングは0～50の範囲でなければなりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्षैतिज पैडिंग 0 और 50 के बीच होनी चाहिए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O espaçamento horizontal deve estar entre 0 e 50.")
	return /** @type {LocalizedString} */ ("Horizontal padding must be between 0 and 50")
});